import { lazy, RefObject, Suspense } from 'react';
import { EmptyState, Center } from '@cad-arc';
import { ApiFederatedQueriesRequest } from 'mark43-federated-search/dist/lib/generated/api-types/models-federated-query-ApiFederatedQueriesRequest';
import { FederatedQueryResultDetailsExternalProps } from 'mark43-federated-search/dist/lib/components';
import { LoadingIndicator } from '../common/components/loading-indicator';

const FederatedQueryResultDetailsList = lazy(() =>
    import('federated-search/FederatedQueryResultDetailsList').then((module) => ({
        default: module.FederatedQueryResultDetailsList,
    }))
);

type FederatedSearchQueryResultsProps = {
    filters: ApiFederatedQueriesRequest | undefined;
    renderButtons: FederatedQueryResultDetailsExternalProps['renderButtons'];
    eventNumber: number | undefined;
    exportButtonContainerRef: RefObject<HTMLElement> | undefined;
    downloadFiles:
        | ((
              files: {
                  name: string;
                  url: string;
              }[]
          ) => Promise<void> | void)
        | undefined;
};

export function FederatedSearchQueryResults(props: FederatedSearchQueryResultsProps) {
    return props.filters?.federatedQueryIds?.length ? (
        <Suspense fallback={<LoadingIndicator />}>
            <FederatedQueryResultDetailsList {...props} />
        </Suspense>
    ) : (
        <Center height="100%">
            <EmptyState title="No Query Results" />
        </Center>
    );
}
